import "./Aboutme.css";

export default function AboutMe() {
  return (
    <section id="about" className="container py-5">
      <h2>About Me</h2>

      <p>
        I am a junior front-end developer and a third-year Economics student
        with a diploma in web development from
        <strong> SheCodes </strong>. I am passionate about building clean,
        responsive, and user-friendly web interfaces.

        <br /><br />

        I focus on learning modern front-end technologies, improving user
        experience, and developing practical web solutions.I am eager to
        contribute my growing technical skills, analytical background, and
        willingness to learn in a professional development environment.
      </p>
    </section>
  );
}
